import React from 'react'
import HistoryList from './HistoryList'

const History = () => {
    return (
        <div className = "history">
            <h3>History</h3>
            <HistoryList/>
        </div>
    )
}

export default History
